import React, { Component } from "react";
import { BootstrapInput } from "app/components/common/BootStrapInput";
import Highcharts from "highcharts/highcharts.js";
import HighchartsReact from "highcharts-react-official";
import CountryChart from "app/components/charts/CountryChart";
import { FormControl, MenuItem, Select, Typography } from "@mui/material";

class RegionalConcentrations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countryData: null,
      topology: null,
    };
  }

  componentDidMount = () => {
    fetch("https://code.highcharts.com/mapdata/countries/us/us-all.topo.json")
      .then((response) => response.json())
      .then((json) => {
        this.setState({ topology: json });
      });

    // this.props.regionalConcentrationData.forEach(item => {
    //     item.custom = {
    //         stateName: item.state
    //     };
    //     });
    // this.setState({ countryData: this.props.regionalConcentrationData});
  };

  render() {
    var concentrationData = this.props.regionalConcentrationData;

    concentrationData.forEach((item) => {
      item.custom = {
        stateName: item.state,
        value: item.tooltip_value,
      };
      item.value = item.map_value;
    });

    let value_label_map = {}

    concentrationData.forEach((item) => {
      value_label_map[item.map_value] = item.tooltip_value
    });

    const { topology, countryData } = this.state;
    var maxValue;
    var minValue;

    if (concentrationData) {
      maxValue = getMax(concentrationData, "value");
      minValue = getMin(concentrationData, "value");
    }

    return (
      <div className="graph-wrapper screen-left-graph-container">
        <div className="graph-title-container-screen graph-title-container-screen3">
          <div className="graph-dropdown graph-dropdown-3">
            <FormControl sx={{ width: "290px" }}>
              {/* <Typography variant="inherit" className="form-metrics-header">
                Industry
              </Typography> */}
              <Select
                value={this.props.industryTypeSelected}
                onChange={this.props.handleIndustryTypeChange}
                input={<BootstrapInput />}
                inputProps={{ "aria-label": "Without label" }}
                className="select-mui"
                displayEmpty
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,

                  PaperProps: {
                    sx: { maxHeight: "400px" },
                  },
                }}
              >
                <MenuItem disabled value="">
                  <Typography variant="inherit" noWrap>
                    Select an Industry
                  </Typography>
                </MenuItem>
                {this.props.industryTypes.length
                  ? this.props.industryTypes.map((name, i) => (
                    <MenuItem key={i} value={name}>
                      <Typography variant="inherit" noWrap>
                        {name}
                      </Typography>
                    </MenuItem>
                  ))
                  : null}
              </Select>
            </FormControl>
          </div>
          {/* <div className="graph-dropdown graph-dropdown-3">
            <FormControl sx={{ width: "290px" }}>
              <Select
                value={"All Jobs"}
                input={<BootstrapInput />}
                inputProps={{ "aria-label": "Without label" }}
                className="select-mui"
                defaultValue={"All Jobs"}
                disabled
                displayEmpty
              >
                <MenuItem disabled value="">
                  <Typography variant="inherit" noWrap>
                    Select a Job Type
                  </Typography>
                </MenuItem>
                <MenuItem key={"All Jobs"} value={"All Jobs"}>
                  <Typography variant="inherit" noWrap>
                    {"All Jobs"}
                  </Typography>
                </MenuItem>
              </Select>
            </FormControl>
          </div> */}
        </div>
        <div className="graph-screen">
          <div className="map-title">Regional Concentration</div>
          {topology && concentrationData ? (
            concentrationData.length != 0 ? (
              <CountryChart
                containerId={"concentrationMap"}
                height={"600px"}
                topology={topology}
                data={concentrationData}
                colorAxis={{
                  minColor: "#91003f",
                  maxColor: "#034e7b",
                  stops: [
                    [0, '#91003f'],
                    [0.1, "#ce1256"],
                    [0.2, "#e7298a"],
                    [0.3, "#df65b0"],
                    [0.4, "#c994c7"],
                    [0.5, '#F1EEF6'],
                    [0.6, "#74a9cf"],
                    [0.7, "#3690c0"],
                    [0.8, "#0570b0"],
                    [1, "#034e7b"],
                  ],
                  labels: {
                    formatter: function () {
                      return value_label_map[this.value]
                    }
                  },
                  tickPositions: [minValue, maxValue],
                }}
                tooltipFormatter={function () {
                  let tooltip = "LQ: <b>" + this.point.custom.value + "</b><br>";
                  tooltip +=
                    "State: <b>" + this.point.custom.stateName + "</b><br>";
                  tooltip += "Year: <b>" + 2023 + "</b>";
                  return tooltip;
                }}
              />
            ) : (
              <div style={{ textAlign: "center" }}> No data available </div>
            )
          ) : null}
        </div>
      </div>
    );
  }
}

function getMax(arr, prop) {
  var max;
  for (var i = 0; i < arr.length; i++) {
    if (max == null || parseFloat(arr[i][prop]) > parseFloat(max[prop]))
      max = arr[i];
  }
  return max[prop];
}

function getMin(arr, prop) {
  var min;
  for (var i = 0; i < arr.length; i++) {
    if (min == null || parseFloat(arr[i][prop]) < parseFloat(min[prop]))
      min = arr[i];
  }
  return min[prop];
}

export default RegionalConcentrations;
